module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"metersTitle":"Controlling","normalizationStation":"Klimastation","normalizationTemperature":"Normtemperatur","normalizationAltitude":"Höhe"}}')
  delete Component.options._Ctor
}
